/**
 * Created by Fayaz on 3/22/2018.
 */
import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import {AuthenticationService} from './services/authentication.service';
import {Globals} from "./services/globals";
import {HelperService} from './services/helper.service';
import {NgxSpinnerService} from "ngx-spinner";

@Injectable()
export class RouteResolver implements Resolve<Observable<string>> {
    constructor(private authenticationService: AuthenticationService,
                private globals: Globals,
                private helperService: HelperService,
                private spinner: NgxSpinnerService,
            ) {}

    resolve(route: ActivatedRouteSnapshot) {
        var routeData = route.routeConfig.data;
        this.spinner.show();
        if (routeData.hasOwnProperty('id')) {
            var params: any = {companyID: this.helperService.getSelectedCompanyId(),
                               navigationMenuID: routeData.id};

                               
            return this.authenticationService.checkUserGroupAccessRights()
                .get(params)
                .map(data => {
                    var data: any = data.data.data;
                    this.spinner.hide();
                    if (routeData.hasOwnProperty('crud')) {
                        var crud: any = routeData.crud;
                        if (!data[crud]) {
                           return this.handleError();
                        }
                     
                    }
                    return data;

                })
                .catch(() => {
                   return this.handleError();
                });
        } else {
            return this.handleError();
        }
    }

    handleError() {
        this.helperService.go('401');
        return Observable.of(null);
        //return Observable.empty();
    }
}



// WEBPACK FOOTER //
// /app/src/app/route.resolver.ts